"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestConfiguration = void 0;
const Configuration_1 = require("./Configuration");
class TestConfiguration extends Configuration_1.Configuration {
    constructor() {
        super();
        this.className = 'TestConfiguration';
    }
    static fromScratch() {
        return new TestConfiguration();
    }
    fromScratch() {
        return TestConfiguration.fromScratch();
    }
    clone() {
        return this;
    }
    duplicate() {
        return this;
    }
}
exports.TestConfiguration = TestConfiguration;
//# sourceMappingURL=TestConfiguration.js.map